import Content from "@/components/Content.tsx";
import MatchSummaryPage from "@/friendlyWagers/MatchSummaryPage.tsx";
import Header from "@/Header.tsx";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";

/** A game's Friendly Wagers market in full (organizers always; players once tips are shown). */
export const Route = createFileRoute('/_app/friendly-wagers/summary/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    return <>
        <Header />
        <Content>
            <MatchSummaryPage gameUid={params.game_uid!} />
        </Content>
    </>
}
